<template>
  <div class="excuse-modal-wrapper" v-if="show">
    <modal @close="$emit('close')">
      <h3 slot="header" class="excuse-modal-header">
        <md-icon>assignment</md-icon>
        بيانات الحضور
      </h3>
      <div slot="body" class="excuse-modal-body">
        <!-- Employee & Date Info -->
        <div class="info-banner" v-if="rowData">
          <div class="info-item">
            <md-icon>person</md-icon>
            <span>{{ rowData.employeeName }}</span>
          </div>
          <div class="info-item">
            <md-icon>event</md-icon>
            <span>{{ formatDate(rowData.date) }} - {{ rowData.day }}</span>
          </div>
          <div class="info-item">
            <md-icon>info</md-icon>
            <span
              :class="rowData.isAbsent ? 'status-absent' : 'status-present'"
            >
              {{ rowData.status }}
            </span>
          </div>
        </div>

        <div class="md-layout excuse-content">
          <!-- Shift Info Section -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="section-card">
              <md-card-header class="section-header">
                <md-icon>schedule</md-icon>
                <div class="md-title">الدوام</div>
              </md-card-header>
              <md-card-content v-if="rowData && rowData.shift">
                <div class="shift-info">
                  <div class="shift-name">
                    <strong>{{ rowData.shift.name || "-" }}</strong>
                  </div>
                  <div class="shift-times">
                    <div class="time-box time-start">
                      <span class="time-label">من</span>
                      <span class="time-value">{{
                        rowData.dayShift ? rowData.dayShift.begin : "-"
                      }}</span>
                    </div>
                    <div class="time-box time-end">
                      <span class="time-label">إلى</span>
                      <span class="time-value">{{
                        rowData.dayShift ? rowData.dayShift.end : "-"
                      }}</span>
                    </div>
                  </div>
                </div>
              </md-card-content>
              <md-card-content v-else>
                <p class="no-data">لا توجد معلومات دوام</p>
              </md-card-content>
            </md-card>
          </div>

          <!-- Signs Table Section -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="section-card">
              <md-card-header class="section-header">
                <md-icon>fingerprint</md-icon>
                <div class="md-title">سجل البصمات</div>
              </md-card-header>
              <md-card-content class="signs-content">
                <md-table
                  v-if="
                    rowData && rowData.allSigns && rowData.allSigns.length > 0
                  "
                  v-model="rowData.allSigns"
                  class="signs-table"
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <!-- <md-table-cell md-label="اليوم">{{
                      item.day
                    }}</md-table-cell> -->
                    <md-table-cell md-label="الوقت">{{
                      item.timeSpan
                    }}</md-table-cell>
                    <md-table-cell md-label="نوع البصمة">
                      <md-chip
                        :class="item.type == 1 ? 'md-success' : 'md-danger'"
                      >
                        {{ item.typeString }}
                      </md-chip>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <div v-else class="no-signs">
                  <md-icon>warning</md-icon>
                  <p>لا توجد بصمات مسجلة لهذا اليوم</p>
                </div>
              </md-card-content>
            </md-card>
          </div>

          <!-- Excuse Type Select -->
          <div class="md-layout-item md-size-100 mt-25" style="height: 260px">
            <md-card class="section-card excuse-type-card">
              <md-card-header class="section-header">
                <md-icon>description</md-icon>
                <div class="md-title">نوع العذر</div>
              </md-card-header>
              <md-card-content class="mt-25">
                <!-- <div class="md-layout-item md-small-size-100 ml-15 mt-25"> -->
                <md-field class="excuse-select mt-25">
                  <label>اختر نوع العذر *</label>
                  <md-select v-model="selectedExcuseType">
                    <md-option value="1">حضور متأخر</md-option>
                    <md-option value="2">خروج مبكر / إذن خروج</md-option>
                    <md-option value="3">غياب</md-option>
                    <md-option value="4">خروج بدون بصمة</md-option>
                  </md-select>
                </md-field>
                <!-- </div> -->
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
      <div slot="footer" class="excuse-modal-footer">
        <md-button
          @click="handleConfirm"
          :disabled="loading"
          class="md-success md-raised"
        >
          <md-icon v-if="!loading">check</md-icon>
          <md-progress-spinner
            v-if="loading"
            :md-diameter="20"
            :md-stroke="3"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <span v-if="loading">جاري الحفظ...</span>
          <span v-else>حفظ</span>
        </md-button>
        <md-button @click="$emit('close')" class="md-danger md-raised">
          <md-icon>close</md-icon>
          إلغاء
        </md-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "../modal.vue";
import moment from "moment";

export default {
  name: "ExcuseModal",
  components: {
    Modal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedExcuseType: null,
    };
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.selectedExcuseType = null;
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    },
    handleConfirm() {
      if (!this.selectedExcuseType) {
        this.$emit("validation-error", "عفواً، الرجاء اختيار نوع العذر");
        return;
      }
      this.$emit("confirm", {
        excuseType: this.selectedExcuseType,
        rowData: this.rowData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Excuse Modal - Simple RTL Design */
.excuse-modal-wrapper {
  /* Modal backdrop - scrollable container */
  ::v-deep .modal-backdrop {
    overflow-y: auto !important;
    align-items: flex-start !important;
    padding: 30px 15px !important;
    box-sizing: border-box !important;
  }

  /* Modal box - auto height */
  ::v-deep .modal {
    height: auto !important;
    max-height: none !important;
    width: 800px !important;
    max-width: 100% !important;
    margin: 0 !important;
    overflow: visible !important;
  }

  ::v-deep .modal-body {
    padding: 0 !important;
    overflow: visible !important;
  }

  ::v-deep .modal-header {
    background: #4caf50;
    color: white !important;
    padding: 15px 20px !important;
    // direction: rtl;

    h3 {
      color: white;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;

      .md-icon {
        color: white !important;
      }
    }

    .btn-close {
      color: white !important;
    }
  }

  ::v-deep .modal-footer {
    flex-direction: row !important;
    justify-content: flex-start !important;
    gap: 10px;
    padding: 15px 20px !important;
    // direction: rtl;
  }
}

/* Info Banner */
.info-banner {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 12px 20px;
  background: #e3f2fd;
  border-bottom: 1px solid #bbdefb;
  // direction: rtl;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #1565c0;

  .md-icon {
    color: #1976d2 !important;
    font-size: 18px !important;
  }
}

.status-absent {
  color: #d32f2f !important;
  font-weight: 600 !important;
}

.status-present {
  color: #388e3c !important;
  font-weight: 600 !important;
}

/* Excuse Content - Side by side cards */
.excuse-content {
  padding: 15px;
  padding-bottom: 30px;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 15px;
  overflow: visible !important;
}

.excuse-content > .md-layout-item.md-size-50 {
  flex: 0 0 calc(50% - 10px) !important;
  max-width: calc(50% - 10px) !important;
  min-width: 0 !important;
}

.excuse-content > .md-layout-item.md-size-100 {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}

/* Section Cards */
.section-card {
  margin-bottom: 0 !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: none !important;
  height: 100%;
  overflow: visible !important;
}

.section-header {
  direction: ltr;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 15px !important;

  .md-icon {
    color: #4caf50 !important;
    margin: 0;
  }

  .md-title {
    font-size: 1rem !important;
    font-weight: 600 !important;
    margin: 0;
  }
}

/* Shift Info */
.shift-info {
  text-align: center;
}

.shift-name {
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
}

.shift-times {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.time-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 15px;
  border-radius: 4px;
}

.time-start {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
}

.time-end {
  background: #ffebee;
  border: 1px solid #ef9a9a;
}

.time-label {
  font-size: 0.8rem;
  color: #666;
}

.time-value {
  font-size: 1rem;
  font-weight: 600;
}

/* Signs Content */
.signs-content {
  min-height: 100px;
  padding: 10px !important;
}

.signs-table {
  width: 100%;
}

.no-signs {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  color: #9e9e9e;

  .md-icon {
    font-size: 30px !important;
    color: #ffb74d !important;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
  }
}

.no-data {
  text-align: center;
  color: #9e9e9e;
  padding: 15px;
}

/* Chip Colors */
::v-deep .md-chip {
  &.md-success {
    background-color: #4caf50 !important;
    color: white !important;
  }

  &.md-danger {
    background-color: #f44336 !important;
    color: white !important;
  }
}

/* Excuse Type Card */
.excuse-type-card {
  margin-top: 10px !important;
  overflow: visible !important;

  .md-card-content {
    overflow: visible !important;
    padding-bottom: 20px !important;
  }
}

.excuse-select {
  max-width: 100%;

  ::v-deep .md-menu {
    position: relative !important;
  }

  ::v-deep .md-menu-content {
    position: relative !important;
    max-height: none !important;
    z-index: 9999 !important;
  }
}

/* Footer Buttons */
.excuse-modal-footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  .md-button {
    .md-icon {
      margin-left: 5px;
    }
  }
}

/* ==================== RESPONSIVE DESIGN ==================== */

/* Medium screens (tablets) */
@media (max-width: 768px) {
  .excuse-modal-wrapper {
    ::v-deep .modal {
      width: 95% !important;
    }

    ::v-deep .modal-backdrop {
      padding: 20px 10px !important;
    }
  }

  .info-banner {
    padding: 10px 15px;
    gap: 10px;
  }

  .excuse-content {
    padding: 10px;
    gap: 10px;
  }

  .excuse-content > .md-layout-item.md-size-50 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .shift-times {
    gap: 15px;
  }

  .time-box {
    padding: 6px 12px;
  }
}

/* Small screens (mobile) */
@media (max-width: 480px) {
  .excuse-modal-wrapper {
    ::v-deep .modal-backdrop {
      padding: 10px 5px !important;
    }

    ::v-deep .modal-header {
      padding: 12px 15px !important;

      h3 {
        font-size: 0.95rem;
        gap: 5px;

        .md-icon {
          font-size: 20px !important;
        }
      }
    }

    ::v-deep .modal-footer {
      padding: 12px 15px !important;
      flex-wrap: wrap;
    }
  }

  .info-banner {
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px;
  }

  .info-item {
    font-size: 0.9rem;

    .md-icon {
      font-size: 16px !important;
    }
  }

  .excuse-content {
    padding: 8px;
    gap: 8px;
  }

  .section-header {
    padding: 8px 12px !important;

    .md-title {
      font-size: 0.9rem !important;
    }

    .md-icon {
      font-size: 18px !important;
    }
  }

  .shift-name strong {
    font-size: 0.9rem;
  }

  .shift-times {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .time-box {
    width: 100%;
    max-width: 150px;
    padding: 8px 15px;
  }

  .time-label {
    font-size: 0.75rem;
  }

  .time-value {
    font-size: 0.9rem;
  }

  .signs-content {
    padding: 8px !important;
    min-height: 80px;
  }

  .no-signs {
    padding: 15px;

    .md-icon {
      font-size: 24px !important;
    }

    p {
      font-size: 0.85rem;
    }
  }

  .excuse-type-card {
    .md-card-content {
      padding: 10px !important;
      padding-bottom: 15px !important;
    }
  }

  .excuse-modal-footer {
    justify-content: center;

    .md-button {
      flex: 1;
      min-width: 100px;
    }
  }

  /* Signs table responsive */
  .signs-table {
    font-size: 0.85rem;

    ::v-deep th,
    ::v-deep td {
      padding: 6px 8px !important;
    }
  }

  ::v-deep .md-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    line-height: 24px !important;
    padding: 0 8px !important;
  }
}

/* Extra small screens */
@media (max-width: 360px) {
  .excuse-modal-wrapper {
    ::v-deep .modal-header h3 {
      font-size: 0.85rem;
    }
  }

  .info-item {
    font-size: 0.8rem;
  }

  .excuse-modal-footer .md-button {
    font-size: 0.8rem !important;
    padding: 8px 12px !important;
  }
}
</style>
